import Vue from 'vue'
import humps from 'humps'
import Router from 'vue-router'
import store from '@/store/root'
import firebase from 'firebase/app'
import Home from './views/Home.vue'
import Finance from './views/Finance.vue'
import NotFound from './views/404.vue'
import logOrder from './views/LogIndex'
Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            beforeEnter: (to, from, next) => {
                next({ path: '/login' })
                // next()
            }
        },
        {
            path: '/404',
            component: NotFound,
            name: '',
            hidden: true
        },
        {
            path: '/login',
            name: 'login',
            component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
            beforeEnter: (to, from, next) => {
                let user = store.get('user/objUser')
                if (user) {
                    if (to.path === '/oms/home') {
                        next()
                    } else {
                        next({ path: '/oms/home' })
                    }
                    // next({ path: '/oms/home' })
                } else {
                    if (to.path === '/login') {
                        next()
                    } else {
                        next('/login')
                    }
                }
                // next()
            }
        },
        {
            path: '/about',
            name: 'about',
            component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        },
        {
            path: '/oms',
            name: 'oms',
            component: Finance,
            // beforeEnter: async (to, from, next) => {
            //     next()
            //     // console.log('wwwwwwwwwwww')
            //     // let user = store.get('user/objUser')
            //     // if (user) {
            //     //     console.log(await user.getIdToken())
            //     //     next()
            //     // } else {
            //     //     next({ path: '/login' })
            //     // }
            // },
            children: [
                {
                    path: 'home',
                    name: 'home',
                    meta: { title: 'Home' },
                    component: () => import(/* webpackChunkName: "finance" */ './views/Home.vue')
                },
                {
                    path: 'overview',
                    name: 'overview',
                    meta: { title: 'Overview' },
                    component: () => import(/* webpackChunkName: "finance" */ './views/Overview.vue')
                },
                {
                    path: 'dashboard',
                    name: 'dashboard',
                    meta: { title: 'Dashboard' },
                    component: () => import(/* webpackChunkName: "finance" */ './views/Dashboard.vue')
                },
                {
                    path: 'logOrder',
                    name: 'logOrder',
                    component: logOrder,
                    children: [
                        {
                            path: 'logOrderSearch',
                            name: 'logOrderSearch',
                            meta: { title: 'Log Order Search' },
                            component: () => import(/* webpackChunkName: "Order" */ './views/LogPage/LogOrder.vue')
                        }, {
                            path: 'LogOrderDetail',
                            name: 'LogOrderDetail',
                            meta: { title: 'Log Order Detail' },
                            component: () => import(/* webpackChunkName: "Order" */ './views/LogPage/LogOrderDetail.vue')
                        }, {
                            path: 'LogCreateShipment',
                            name: 'LogCreateShipment',
                            meta: { title: 'Log Create Shipment' },
                            component: () => import(/* webpackChunkName: "Order" */ './views/LogPage/LogCreateShipment.vue')
                        },
                        {
                            path: 'EditedOrder',
                            name: 'EditedOrder',
                            meta: { title: 'Edited Order Log' },
                            component: () => import(/* webpackChunkName: "Order" */ './views/LogPage/EditedOrder.vue')
                        },
                        {
                            path: 'mobileOrder',
                            name: 'mobileOrder',
                            meta: { title: 'Mobile Log Order' },
                            component: () => import(/* webpackChunkName: "Order" */ './views/LogPage/mobileOrder.vue')
                        },
                        {
                            path: 'kpOrderUpload',
                            name: 'Upload KP Order',
                            meta: { title: 'Upload KP Order' },
                            component: () => import(/* webpackChunkName: "Order" */ './views/Order/kpUploadOrder.vue')
                        }
                    ]
                },
                {
                    path: 'exportOrder',
                    name: 'exportOrder',
                    meta: { title: 'Export Order Excel' },
                    component: () => import(/* webpackChunkName: "Order" */ './views/Export/exportOrder.vue')
                },
                {
                    path: 'exportScgStatus',
                    name: 'exportScgStatus',
                    meta: { title: 'Export Scg Status' },
                    component: () => import(/* webpackChunkName: "Order" */ './views/Export/exportScgStatus.vue')
                },
                {
                    path: 'customer',
                    name: 'customerIndex',
                    component: () => import(/* webpackChunkName: "customer" */ './views/Customer/CustomerIndex.vue'),
                    children: [
                        {
                            path: 'customerList',
                            name: 'customerList',
                            meta: { title: 'Customer Detail' },
                            component: () => import(/* webpackChunkName: "customerList" */'./views/Customer/CustomerList.vue')
                        },
                        {
                            path: 'customerRegisLandingPage',
                            name: 'customerRegisLandingPage',
                            meta: { title: 'Customer Register Landing Page' },
                            component: () => import(/* webpackChunkName: "customerRegisLandingPage" */'./views/Customer/CustomerRegisLandingPage.vue')
                        },
                        {
                            path: 'confirmCustomer',
                            name: 'confirmCustomer',
                            meta: { title: 'Confirm Customer' },
                            component: () => import(/* webpackChunkName: "confirmCustomer" */'./views/Customer/ConfirmCustomer.vue')
                        },
                        {
                            path: 'RateCardUploadExcel',
                            name: 'RateCardUploadExcel',
                            meta: { title: 'Rate Card Upload Excel' },
                            component: () => import(/* webpackChunkName: "RateCardUploadExcel" */'./views/Customer/RateCardUploadExcel.vue')
                        },
                        {
                            path: 'approveCustomer',
                            name: 'approveCustomer',
                            meta: { title: 'Approve Customer' },
                            component: () => import(/* webpackChunkName: "ApproveCustomer" */'./views/Customer/ApproveCustomer.vue')
                        },
                        {
                            path: 'allCustomer',
                            name: 'allCustomer',
                            meta: { title: 'All Customer' },
                            component: () => import(/* webpackChunkName: "CustomerNewMenu" */'./views/Customer/AllCustomer.vue')
                        }
                    ]
                },
                {
                    path: 'LeadPool',
                    name: 'LeadPool',
                    component: () => import(/* webpackChunkName: "customer" */ './views/LeadPool/LeadPoolIndex.vue'),
                    children: [
                        {
                            path: 'LeadPoolMain',
                            name: 'LeadPoolMain',
                            meta: { title: 'Lead Pool' },
                            component: () => import(/* webpackChunkName: "courier" */'./views/LeadPool/LeadPoolMain.vue')
                        }
                    ]
                },
                {
                    path: 'courier',
                    name: 'CourierIndex',
                    component: () => import(/* webpackChunkName: "courier" */'./views/Courier/Index.vue'),
                    children: [
                        {
                            path: 'manage',
                            name: 'ManageCourier',
                            meta: { title: 'Manage Courier' },
                            component: () => import(/* webpackChunkName: "courier" */'./views/Courier/Manage.vue')
                        },
                        {
                            path: 'notify',
                            name: 'NotifyCourier',
                            meta: { title: 'Notify Courier - FLASH' },
                            component: () => import(/* webpackChunkName: "courier" */'./views/Courier/NotifyFlash/Index.vue')
                        },
                        {
                            path: 'NotifyCourierSCG',
                            name: 'NotifyCourierSCG',
                            meta: { title: 'Booking Courier - SCG' },
                            component: () => import(/* webpackChunkName: "courier" */'./views/Courier/NotifyCourierSCG.vue')
                        },
                        {
                            path: 'sorting-code',
                            name: 'SortingCode',
                            meta: { title: 'Sorting Code' },
                            component: () => import(/* webpackChunkName: "courier" */'./views/Courier/SortingCode.vue')
                        },
                        {
                            path: 'cut-off-time',
                            name: 'cut-off-time',
                            meta: { title: 'Cut Off Time' },
                            component: () => import(/* webpackChunkName: "courier" */'./views/Courier/CutOffTimeFlash.vue')
                        },
                        {
                            path: 'best',
                            name: 'BestManage',
                            meta: { title: 'Best Tracking' },
                            component: () => import(/* webpackChunkName: "courier" */'./views/Courier/BestTracking.vue')
                        },
                        {
                            path: 'thaipost-ems',
                            name: 'ThaipostEMS',
                            meta: { title: 'Thaipost EMS Tracking' },
                            component: () => import(/* webpackChunkName: "courier" */'./views/Courier/ThaipostEmsTracking.vue')
                        },
                        {
                            path: 'AvailableZipcodeSCG',
                            name: 'AvailableZipcodeSCG',
                            meta: { title: 'Available Zipcode SCG' },
                            component: () => import(/* webpackChunkName: "courier" */'./views/Courier/AvailableZipcodeSCG.vue')
                        },
                        {
                            path: 'ExceptZipcodeScg',
                            name: 'ExceptZipcodeScg',
                            meta: { title: 'Except Zipcode Scg' },
                            component: () => import(/* webpackChunkName: "courier" */'./views/Courier/ExceptZipcodeScg.vue')
                        }
                    ]
                },
                {
                    path: 'payment',
                    name: 'PaymentManage',
                    component: () => import(/* webpackChunkName: "payment" */'./views/Payment/PaymentIndex.vue'),
                    children: [
                        {
                            path: 'list',
                            name: 'PaymentList',
                            meta: { title: 'Payment List' },
                            component: () => import(/* webpackChunkName: "payment" */'./views/Payment/List.vue')
                        },
                        {
                            path: 'manage',
                            name: 'PaymentAdd',
                            meta: { title: 'Payment Add' },
                            component: () => import(/* webpackChunkName: "payment" */'./views/Payment/ManageDetailNewTest.vue')
                        }, {
                            path: 'manageTestNew',
                            name: 'PaymentAddTest',
                            meta: { title: 'Payment Add Test' },
                            component: () => import(/* webpackChunkName: "payment" */'./views/Payment/ManageDetailNewTest.vue')
                        }, {
                            path: 'PaymentNew',
                            name: 'PaymentNew',
                            meta: { title: 'Create Payment' },
                            component: () => import(/* webpackChunkName: "payment" */'./views/Payment/PaymentNew.vue')
                        }
                    ]
                },
                {
                    path: 'invoice',
                    name: 'InvoiceManage',
                    component: () => import(/* webpackChunkName: "invoice" */'./views/Invoice/InvoiceIndex.vue'),
                    children: [
                        {
                            path: 'InvoiceList',
                            name: 'invoiceList',
                            meta: { title: 'Invoice List' },
                            component: () => import(/* webpackChunkName: "invoice" */'./views/Invoice/InvoiceList.vue')
                        },
                        {
                            path: 'InvoiceUpload',
                            name: 'InvoiceUpload',
                            meta: { title: 'Invoice Detail' },
                            component: () => import(/* webpackChunkName: "invoice" */'./views/Invoice/InvoiceUpload.vue')
                        },
                        {
                            path: 'InvoiceFlow',
                            name: 'InvoiceFlow',
                            meta: { title: 'Invoice Flow' },
                            component: () => import(/* webpackChunkName: "invoice" */'./views/Invoice/InvoiceFlow.vue')
                        }
                    ]
                }, {
                    path: 'OrderSearch',
                    name: 'OrderSearch',
                    component: () => import(/* webpackChunkName: "invoice" */'./views/Order/orderIndex.vue'),
                    children: [
                        {
                            path: 'OrderManage',
                            name: 'OrderManage',
                            meta: { title: 'Order Manage' },
                            component: () => import(/* webpackChunkName: "invoice" */'./views/Order/OrderManage.vue')
                        },
                        {
                            path: 'ZipcodeSystem',
                            name: 'ZipcodeSystem',
                            meta: { title: 'Zipcode System' },
                            component: () => import(/* webpackChunkName: "courier" */'./views/Order/ZipcodeSystem.vue')
                        }
                    ]
                },
                {
                    path: 'version',
                    name: 'VersionControl',
                    meta: { title: 'Version Control' },
                    component: () => import(/* webpackChunkName: "version" */ './views/Version.vue')
                },
                {
                    path: 'FacebookLiveConnection',
                    name: 'FacebookLiveConnection',
                    meta: { title: 'Facebook Live Connection' },
                    component: () => import(/* webpackChunkName: "version" */ './views/FacebookLiveConnection.vue')
                },
                {
                    path: 'manual',
                    name: 'ManualControl',
                    meta: { title: 'Manual Control' },
                    component: () => import(/* webpackChunkName: "version" */ './views/Manual.vue')
                },
                {
                    path: 'cms',
                    name: 'LearningCenter',
                    component: () => import(/* webpackChunkName: "LearningCenter" */ './views/LearningCenter/index.vue')
                },
                {
                    path: 'user-management',
                    name: 'UserManagement',
                    meta: { title: 'User Management' },
                    component: () => import(/* webpackChunkName: "version" */ './views/UserManagement.vue')
                },
                {
                    path: 'role-management',
                    name: 'RoleManagement',
                    meta: { title: 'Role Management' },
                    component: () => import(/* webpackChunkName: "version" */ './views/RoleManagement.vue')
                },
                {
                    path: 'shipflow',
                    name: 'shipflowIndex',
                    component: () => import(/* webpackChunkName: "customer" */ './views/Customer/CustomerIndex.vue'),
                    children: [
                        {
                            path: 'shipflowPage',
                            name: 'shipflowPage',
                            meta: { title: 'Ship Flow' },
                            component: () => import(/* webpackChunkName: "shipflowPage" */'./views/ShipFlow/ShipFlowBase.vue')
                        },
                        {
                            path: 'bookingcalendar',
                            name: 'bookingcalendar',
                            meta: { title: 'Booking Calendar' },
                            component: () => import(/* webpackChunkName: "shipflowPage" */'./views/ShipFlow/BookingCalendar.vue')
                        },
                        {
                            path: 'bookinghistory',
                            name: 'bookinghistory',
                            meta: { title: 'Booking History' },
                            component: () => import(/* webpackChunkName: "shipflowPage" */'./views/ShipFlow/BookingHistoryBase.vue')
                        }
                    ]
                },
                {
                    path: 'case',
                    name: 'case',
                    component: () => import(/* webpackChunkName: "caseOrder" */'./views/Case/Index.vue'),
                    children: [
                        {
                            path: 'caseOrder',
                            name: 'caseOrder',
                            component: () => import(/* webpackChunkName: "caseOrder" */'./views/Case/CaseOrder.vue')
                        },
                        {
                            path: 'GenerateNotify',
                            name: 'GenerateNotify',
                            component: () => import(/* webpackChunkName: "caseOrder" */'./views/Case/GenerateNotify.vue')
                        },
                        {
                            path: 'CsPerformance',
                            name: 'CsPerformance',
                            component: () => import(/* webpackChunkName: "caseOrder" */'./views/Case/CsPerformance.vue')
                        },
                        {
                            path: 'CustomerCs',
                            name: 'CustomerCs',
                            component: () => import(/* webpackChunkName: "caseOrder" */'./views/Case/CustomerCs.vue')
                        },
                        {
                            path: 'CsProfile',
                            name: 'CsProfile',
                            component: () => import(/* webpackChunkName: "caseOrder" */'./views/Case/CsProfile.vue')
                        }
                    ]
                }
            ]
        },
        {
            path: '*',
            hidden: true,
            redirect: { path: '/404' }
        }
    ]
})

router.beforeEach(async (to, from, next) => {
    // console.log(to, from)
    const genTitle = () => {
        let titleEl = document.querySelector('title')
        if (titleEl) {
            let pathTitle = to.meta.title
            if (pathTitle) {
                titleEl.innerHTML = pathTitle
            } else {
                titleEl.innerHTML = humps.pascalize(to.name)
            }
        }
    }
    genTitle()
    let user = await firebase.auth().currentUser
    if (user) {
        store.set('user/objUser', user)
        // console.log(await user.getIdToken())

        // start >> permission order
        const db = store.get('fgFirbaseApp/oms').firestore()

        const result = await db.collection('order_permission_oms')
        const findEmailInPermission = await result.where('email', 'array-contains', store.get('user/objUser').email).get()
        findEmailInPermission.docs.forEach(permissionName => {
            store.set('permission/' + permissionName.id, true)
        })
        // end >> permission order

        const regexEmailOutSource = RegExp(/@fgoutsource.co/)
        const regexEmailCaseTracking = RegExp(/@devoutsource.co/)
        if (regexEmailOutSource.test(user.email)) {
            store.set('permission/isOutSourceMobileOrder', true)
            if (to.name === 'mobileOrder') {
                next()
                return
            } else {
                if (to.path === '/oms/home') {
                    next()
                    return
                } else {
                    next({ path: '/oms/home' })
                    return
                }
            }
        } if (regexEmailCaseTracking.test(user.email)) {
            store.set('permission/isDevCaseTracking', true)
            // console.log(to)
            if (to.matched[1] && to.matched[1].name === 'case') {
                next()
                return
            } else {
                if (to.path === '/oms/home') {
                    next()
                    return
                } else {
                    next({ path: '/oms/home' })
                    return
                }
            }
        } else {
            store.set('permission/isOutSourceMobileOrder', false)
            store.set('permission/isDevCaseTracking', false)
        }
    } else {
        if (to.path === '/login') {
            next()
            return
        } else {
            next('/login')
            return
        }
    }
    next()
})

export default router
